import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../Utils/Axios";
import { resolveMediaUrl } from "../Utils/media";

const monthName = (dateString) =>
  new Date(dateString).toLocaleDateString("en-US", { month: "long" });
const dayNumber = (dateString) => new Date(dateString).getDate() || 1;

const fallbackImages = [
  "/assets/images/blog/blog-img-01.png",
  "/assets/images/blog/blog-img-02.png",
  "/assets/images/blog/blog-img-03.png",
  "/assets/images/blog/blog-img-04.png",
  "/assets/images/blog/blog-img-05.png",
  "/assets/images/blog/blog-img-06.png",
];

const Blogs = () => {
  const [searchParams] = useSearchParams();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/api/blogs", {
          params: {
            tag: searchParams.get("tag") || undefined,
            category: searchParams.get("category") || undefined,
            q: searchParams.get("q") || undefined,
          },
        });
        setBlogs(res.data?.blogs || []);
      } catch (err) {
        setBlogs([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [searchParams]);

  const blogCards = useMemo(
    () =>
      blogs.map((blog, index) => ({
        ...blog,
        image: resolveMediaUrl(blog.coverImage) || fallbackImages[index % fallbackImages.length],
      })),
    [blogs]
  );

  return (
    <div>
      <div className="inner-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="banner-content text-center">
                <h1>Blog</h1>
                <span />
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Blog
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-grid-area pt-120 mb-120">
        <div className="container">
          <div className="row g-lg-4 gy-5 justify-content-center">
            {loading ? (
              <div className="col-lg-12 text-center">
                <p>Loading blogs...</p>
              </div>
            ) : blogCards.length === 0 ? (
              <div className="col-lg-12 text-center">
                <p>No blogs published yet.</p>
              </div>
            ) : (
              blogCards.map((blog) => (
                <div className="col-lg-4 col-md-6 col-sm-10 mb-20" key={blog._id}>
                  <div className="recent-article-wrap">
                    <div className="recent-article-img">
                      <img className="img-fluid" src={blog.image} alt={blog.title} />
                      <div className="publish-area d-xl-none d-flex">
                        <Link to={`/blog-details/${blog.slug}`}>
                          <span>{String(dayNumber(blog.publishedAt)).padStart(2, "0")}</span>
                          {monthName(blog.publishedAt)}
                        </Link>
                      </div>
                    </div>
                    <div className="recent-article-content">
                      <div className="recent-article-meta">
                        <div className="publish-area">
                          <Link to={`/blog-details/${blog.slug}`}>
                            <span>{String(dayNumber(blog.publishedAt)).padStart(2, "0")}</span>
                            {monthName(blog.publishedAt)}
                          </Link>
                        </div>
                        <ul>
                          <li>
                            <Link to={`/blog-details/${blog.slug}`}>
                              <img src="/assets/images/icon/comment.svg" alt="" />
                              {blog.commentsCount || 0} Comments
                            </Link>
                          </li>
                          <li>
                            <Link to={`/blog-details/${blog.slug}`}>
                              <img src="/assets/images/icon/user.svg" alt="" />
                              {blog.authorName || "System Admin"}
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <h4>
                        <Link to={`/blog-details/${blog.slug}`}>{blog.title}</Link>
                      </h4>
                      <p>{blog.excerpt}</p>
                      <div className="explore-btn">
                        <Link to={`/blog-details/${blog.slug}`}>
                          <span>
                            <img src="/assets/images/icon/explore-elliose.svg" alt="" />
                          </span>{" "}
                          Explore More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
